import React from 'react';

const toPersianDigits = (s: string) => s.replace(/[0-9]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'[parseInt(d, 10)]);

interface ChestIconProps {
  count?: number;
  onClick?: () => void;
}

const ChestIcon: React.FC<ChestIconProps> = ({ count = 0, onClick }) => (
  <div 
    className={`relative w-full h-full ${onClick ? 'cursor-pointer hover:scale-110 transition-transform duration-200' : ''}`}
    onClick={onClick}
  >
  <svg
    className="w-full h-full"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect
        fill="#C58C6E"
        x="32"
        y="32"
        width="448"
        height="448"
        rx="60"
        ry="60"
      ></rect>
      <rect
        fill="#FCE47C"
        x="80"
        y="80"
        width="352"
        height="140"
        rx="30"
        ry="30"
      ></rect>
      <g transform="translate(80, 272)">
        <rect fill="#FCE47C" x="0" y="0" width="352" height="52"></rect>
        <rect fill="#FAD453" x="0" y="52" width="352" height="52"></rect>
        <rect fill="#FCE47C" x="0" y="104" width="352" height="52"></rect>
      </g>
      <rect fill="#C58C6E" x="80" y="230" width="352" height="32"></rect>
      <path
        d="M216,230 H296 V286 A40,40 0 0,1 216,286 Z"
        fill="#4D5382"
      ></path>
    </g>
  </svg>
    {count > 0 && (
      <div className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center border-2 border-white font-bold p-0">
        {toPersianDigits(String(count))}
      </div>
    )}
  </div>
);

export default ChestIcon;
